import script from "./AtomTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomTitle.vue?vue&type=script&lang=ts&setup=true"

import "./AtomTitle.vue?vue&type=style&index=0&id=811cad82&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-811cad82"]])

export default __exports__